export function getMobileGatewayUrl(origin: string) {
    return `${origin}/fleet`;
}
